export enum AssetImage {
  AgnesRebel = 1,
  Contact,
  DefaultAvatar,
  FooterBackground,
  MasterCardAndVisa,
  MultimediaBroken,
  MultimediaPlaceholder,
  NatWithLove,
  PaymentSystem,
  PayU,
  PayUInstallments,
  PayUInstallmentsBanner,
  PureBeautyLogo,
  PureBeautyLogoWhite,
  SampleBoxCurrentlyOnSaleOne,
  SampleBoxCurrentlyOnSaleTwo,
  SampleBoxDetailsImage,
  SampleProfileImage,
  SignInBackground,
  SlideShowOne,
  SlideShowThree,
  SlideShowTwo,
  NewsletterBanner,
}
